var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sms-biz-message-send-input"},[_c('AppScrollbar',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"input-wrap"},[_c('el-input',{attrs:{"size":"mini","type":"textarea","placeholder":"填写短信内容"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }